import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, isDevMode } from '@angular/core';
import { FirebaseService } from 'src/app/service/firebase.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { TagsmanagementComponent } from '../../../modals/tagsmanagement/tagsmanagement.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ListSelectionModalComponent } from '../../../modals/list-selection-modal/list-selection-modal.component';
import { UtilsService } from '../../../services/utils.service';
import { ModalMainComponent } from '../../../modals/modal-main/modal-main.component';
import { ConfirmModalComponent } from '../../../modals/confirm-modal/confirm-modal.component';
import { TranslationPipe } from '../../../shared/pipes/translation.pipe';
import { SharedService } from '../../../services/shared.service';
import { DateManagementComponent } from '../../../modals/date-management/date-management.component';
import { UserlistComponent } from '../../../modals/userlist/userlist.component';
import { Timestamp } from '@firebase/firestore-types';
import { SvginteractmodalComponent } from '../../../modals/svginteractmodal/svginteractmodal.component';
import { ModalCustomLockComponent } from '../../../modals/modal-custom-lock/modal-custom-lock.component';
@Component({
  selector: 'app-content-list',
  templateUrl: './content-list.component.html',
  styleUrls: ['./content-list.component.scss']
})
export class ContentListComponent implements OnInit, OnChanges, AfterViewInit {

  /*private items: any;

  @Input() set setItems(values: any) {
    this.items = values;
  };*/


  @Input() items;
  @Input() contentData;
  @Input() moduleId;
  @Input() selectedFolder;
  @Input() latestUpdate;
  public displayRepair: boolean = false;
  public repairInProgress: boolean = false;
  public isWorking: boolean = false;
  public selectedFolderBehavior: any = null;
  public showSVGTooltip: boolean = false;
  public svgCount: number = 0;
  @Output() latestUpdateChange: EventEmitter<any> = new EventEmitter<any>();
  private dialogRef: MatDialogRef<any>;


  @Output() contentListEvent: EventEmitter<any> = new EventEmitter<any>();
  // one dimensional input model
  // items: Array<number> = Array.from({ length: 21 }, (v, k) => k + 1);
  // two dimensional table matrix representing view model
  itemsTable: Array<number[]>;

  // fix column width as defined in CSS (150px + 5px margin)
  boxWidth = 175;
  // calculated based on dynamic row width
  columnSize: number;
  customLoad: string = '';

  constructor(
    public _firebase: FirebaseService,
    public dialog: MatDialog,
    private _utils: UtilsService,
    private _ref: ChangeDetectorRef,
    public translation: TranslationPipe,
    protected _shareVar: SharedService
  ) { }

  ngOnInit(): void {
    this.manageCustomLoad();
    console.log(this.selectedFolder)



  }

  ngAfterViewInit() {

    /*
        setTimeout(() => {
          this.checkIfContentDataAsMediaOptions(this.contentData);
          console.log("AFTER VIEW INIT", this.contentData, JSON.parse(JSON.stringify(this.contentData)));
        }, 1000)*/

  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("CHANGES:", changes)
    if (changes.items != undefined)
      this.items = changes.items.currentValue;

    if (changes.contentData != undefined)
      this.contentData = changes.contentData.currentValue;

    if (changes.moduleId != undefined)
      this.moduleId = changes.moduleId.currentValue

    if (changes.selectedFolder != undefined)
      this.selectedFolder = changes.selectedFolder.currentValue


    if (this.contentData) {
      /*    setTimeout(() => {
            this.checkIfContentDataAsMediaOptions(this.contentData)
          }, 10000)*/

    }


    console.log(this.selectedFolder.displayName, this.selectedFolder, this.selectedFolder.type, this.selectedFolder.mediaOptions)
    if (this.selectedFolder.mediaOptions) {
      this.selectedFolderBehavior = this.selectedFolder.mediaOptions.customBehavior
    }
    else
      this.selectedFolderBehavior = null;

    if (this.selectedFolderBehavior?.dataType == 'generic') {
      console.log(this.selectedFolderBehavior?.dataType)
      this.showSVGTooltip = true;
    }
    else
      this.showSVGTooltip = false;

    console.log(this.showSVGTooltip)


    this.items.map(v => {
      if (v.name.includes('.svg'))
        v.asBackground = false
    })

    let itemSVG = this.items.find(v => v.name.includes('.svg'))

    if (itemSVG)
      itemSVG.asBackground = true;

    this.initTable();
    this._ref.detectChanges();
    //  setTimeout(() => {

    //  }, 1000)

  }

  drop(event: CdkDragDrop<string[]>) {




    /* let previousIndex = event.item.data;
     let nextIndex = event.container.data as any;*/

    moveItemInArray(this.items, event.previousIndex, event.currentIndex);



    // console.log(this.items, this.contentData)
    //   this.itemsChange.emit(this.items)
    // this._firebase.updateConfigModule({ fileTree: this.contentData }, this.moduleId);



  }



  manageCustomLoad() {




    if (this._firebase.user.uid == 'OvOSoNvxFcd2KDbsLQls32kaveW2')
      this.customLoad = 'malta'
    else if (this._firebase.user.uid == 'TW0LZKlTEkPeU2up4L462QVlWtk1')
      this.customLoad = 'dev'
    // console.log("CUSTOM LOAD", this.customLoad, this._firebase.user.uid)
  }



  setElementCustomBehavior(item, behaviorType, dataType) {

    console.log(behaviorType, dataType)


    if (!item.mediaOptions.customBehavior) {
      item.mediaOptions.customBehavior = { enable: true, behaviorType: behaviorType, dataType: dataType }
    }
    else {

      if (behaviorType == item.mediaOptions.customBehavior.behaviorType && dataType == item.mediaOptions.customBehavior.dataType)

        item.mediaOptions.customBehavior.enable = !item.mediaOptions.customBehavior.enable
      else
        item.mediaOptions.customBehavior = { enable: true, behaviorType: behaviorType, dataType: dataType }
    }

    this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d; this.latestUpdateChange.emit(d);
      this._firebase.updateMediaData({ customBehavior: item.mediaOptions.customBehavior }, item.id)
    })

  }


  setPdfDisplay(item, display) {
    console.log(item, display)

    // if (!item.mediaOptions.pdfDisplay) {
    item.mediaOptions.pdfDisplay = display;
    //}
    this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d; this.latestUpdateChange.emit(d);
      this._firebase.updateMediaData({ pdfDisplay: item.mediaOptions.pdfDisplay }, item.id)
    })
  }

  checkIfAvailable(type) {
    //Proximum
    let availableList = ['lEeOibslLMXnpnPM1vHrgtNymq92', 'TW0LZKlTEkPeU2up4L462QVlWtk1'];

    if (type == 'michelin')
      availableList.push('V0lWR5Q8ndOPVvas88sAoiHGfLu2')


    if (type == 'ofb') {
      availableList.push('6budstAuZHRkOQr9rwwbsFWvyB83')
    }

    if (type == 'sogea') {
      availableList.push('QqSGO0yD7kUjhO7UC0Kn91iEJ2A3')
    }
    // console.log(this._firebase.user.uid)
    if (isDevMode() || this._firebase.user.role == 'admin' || availableList.includes(this._firebase.user.uid))
      return true;
    else
      return false;

    //  else if (this._shareVar.user)
  }

  setElementVisibility(item) {
    // console.log(item)

    if (item.mediaOptions.active != undefined)
      item.mediaOptions.active = !item.mediaOptions.active
    else
      item.mediaOptions.active = false;


    //console.log(new Date(this.latestUpdate.seconds * 1000 + this.latestUpdate.nanoseconds / 1000000))

    this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d; this.latestUpdateChange.emit(d);
      this._firebase.updateMediaData({ active: item.mediaOptions.active }, item.id)
    })


  }


  setElementLock(item) {
   // console.log(this._shareVar.checkAppVersion('1.21.31', 'media'))
    if (this._shareVar.checkAppVersion('1.21.31', 'media')) {
      console.log("CUSTOM LOCK")
      console.log(item.mediaOptions.lockType)

      /* UNLOCK IF LOCKED */
      /*   if (item.mediaOptions.lockType != null) {
           item.mediaOptions.lock = false;
           item.mediaOptions.lockType = null;
           this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
             this.latestUpdate = d; this.latestUpdateChange.emit(d);
             this._firebase.updateMediaData({ lockType: item.mediaOptions.lockType, lock: item.mediaOptions.lock }, item.id)
           })
           return;
         }
   
         else {*/
      this.dialogRef = this.dialog.open(ModalCustomLockComponent, {
        width: "30vw",
        height: "30vh",
        data: item.mediaOptions
      })


      this.dialogRef.afterClosed().subscribe(result => {
        console.log(result)
        if (result) {

          if (result.type != 'unlock')
            item.mediaOptions.lock = true;
          else {
            item.mediaOptions.lock = false

          }
          item.mediaOptions.lockType = result;

          this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
            this.latestUpdate = d; this.latestUpdateChange.emit(d);
            this._firebase.updateMediaData({ lockType: item.mediaOptions.lockType, lock: item.mediaOptions.lock }, item.id)
          })

        }

      })
      //   }


    }
    else {

      console.log("DEFAULT LOCK")
      if (item.mediaOptions.lock != undefined)
        item.mediaOptions.lock = !item.mediaOptions.lock
      else
        item.mediaOptions.lock = true;


      this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
        this.latestUpdate = d; this.latestUpdateChange.emit(d);
        this._firebase.updateMediaData({ lock: item.mediaOptions.lock }, item.id)
      })
    }

  }



  getItemsTable(rowLayout: Element): number[][] {
    // calculate column size per row
    const { width } = rowLayout.getBoundingClientRect();
    const columnSize = Math.round(width / this.boxWidth);
    // view has been resized? => update table with new column size
    if (columnSize != this.columnSize) {
      this.columnSize = columnSize;
      this.initTable();
    }



    // console.log(this.itemsTable)
    return this.itemsTable;
  }




  initTable() {


    // console.log(this.items)

    // create table rows based on input list
    // example: [1,2,3,4,5,6] => [ [1,2,3], [4,5,6] ]
    this.itemsTable = this.items
      .filter((_, outerIndex) => outerIndex % this.columnSize == 0) // create outter list of rows
      .map((
        _,
        rowIndex // fill each row from...
      ) =>
        this.items.slice(
          rowIndex * this.columnSize, // ... row start and
          rowIndex * this.columnSize + this.columnSize // ...row end
        )
      );
  }

  reorderDroppedItem(event: CdkDragDrop<number[]>) {
    // same row/container? => move item in same row
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      // different rows? => transfer item from one to another list
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    // update items after drop: flatten matrix into list
    // example: [ [1,2,3], [4,5,6] ] => [1,2,3,4,5,6]
    this.items = this.itemsTable.reduce(
      (previous, current) => previous.concat(current),
      []
    );

    // re-initialize table - makes sure each row has same numbers of entries
    // example: [ [1,2], [3,4,5,6] ] => [ [1,2,3], [4,5,6] ]

    this.updateContentDataAfterDrop(this.items)
    this.initTable();


    // console.log(this.contentData)

  }



  checkIfContentDataAsMediaOptions(data) {
    console.log(this.items)
    let needRepair: boolean = false;
    //      console.log("GET SVG", this.items.find(v => v.name.includes('.svg')))



    data.forEach(item => {
      //     console.log(item)
      if (!item.mediaOptions && (item.type == 'file' || item.type == 'folder' || item.type == 'web')) {
        console.log("ERROR DETECTED")
        needRepair = true;
      }
    })

    /*  console.log(data);
   
      let loopthrough = (tab) => {
   
   
        tab.forEach((item) => {
        ///  console.log(item)
          
   
          console.log(item)
          if (!item.mediaOptions && (item.type == 'file' || item.type == 'folder' || item.type == 'web')) {
            console.log("ERROR DETECTED")
            needRepair = true;
          }
   
          if (item.children) {
            loopthrough(item.children);
          }
        })
      }
        loopthrough(data)*/
    this.displayRepair = needRepair;
    console.log("REPAIR NEEDED", needRepair)
  }


  updateContentDataAfterDrop(items) {



    if (this.selectedFolder == 'root')
      this.contentData = this.items
    else {



      let loopThrough = (tab) => {
        tab.forEach((item) => {

          if (item.id == this.selectedFolder.id)
            item.children = items


          if (item.children != undefined && item.children.length > 0) {

            loopThrough(item.children)
          }

        })
      }



      loopThrough(this.contentData)

    }

    this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d; this.latestUpdateChange.emit(d);
    })
  }


  assignToSpecUser(item) {
    this.dialogRef = this.dialog.open(UserlistComponent, {
      width: '30vw',
      height: '30vh',
      data: { type: 'subuser' }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //console.log(result)


        //      item.mediaOptions

        //if (item.mediaOptions.active != undefined) {
        //      item.mediaOp
        // }
        /*    item.mediaOptions.active = !item.mediaOptions.active
          else
            item.mediaOptions.active = false;*/


        // console.log(new Date(this.latestUpdate.seconds * 1000 + this.latestUpdate.nanoseconds / 1000000))

        this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d; this.latestUpdateChange.emit(d);
          this._firebase.updateMediaData({ assignedUser: result.uid }, item.id)
        })

      }
    })
  }

  repairAllMediaFromCurrentContent() {
    this.repairInProgress = true;
    let promiseArray = [];


    let loopThrough = (tab) => {

      tab.forEach((item) => {
        //  if (item.children)
        //   loopThrough(item.children)



        if (!item.mediaOptions) {


          console.log("NEED TO REPAIR", item)
          //     console.log(promiseArray)
          promiseArray.push(new Promise<any>((resolve, reject) => {
            this.createMedia(item).then(d => {
              item.id = d.id
              console.log(d)

              // console.log(promiseArray.length)
              resolve('OK')
            })

          }))

        }

      })

    }



    loopThrough(this.contentData)

    console.log(promiseArray.length)
    Promise.all(promiseArray).then(d => {
      this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
        this.latestUpdate = d; this.latestUpdateChange.emit(d);
        this.checkIfContentDataAsMediaOptions(this.contentData)
      })

      this.repairInProgress = false;


      console.log("repair complete")
    }).catch(err => {
      console.log(err)
    })

  }

  createMedia(elem) {
    return new Promise<any>((resolve, reject) => {

      switch (elem.type) {
        case "folder":
          //   resolve('FOLDER')
          this._firebase.addMedia('folder', elem.name, { displayName: elem.displayName }).then(d => {

            elem.id = d.id;
            resolve(elem)
          })

          break;
        case "file":
          //   resolve('FILE')

          this._firebase.getFileFromName(elem.name).then(f => {

            if (f) {
              f.defaultName = elem.displayName
              this._firebase.addMedia('file', elem.name, f).then(d => {
                elem.id = d.id;
                resolve(elem);
              })

            }
          })
          break;
        case "web":

          this._firebase.getWebConfigFromName(elem.name, this._shareVar.selectedDevice).then(d => {

            d[0].data.urlConfig.forEach((item) => {
              if (item.name == elem.name || item.name == elem.displayName) {

                this._firebase.addMedia('web', elem.name, { url: item.url, thumbnail: item.thumbnailUrl || '', id: item.id, filename: item.filename || '' }).then(m => {
                  elem.id = m.id
                  resolve(elem)
                })

              }
            })
          })
          break;
        default:
          resolve("UNKNOWN");
      }

    })
  }

  repairMedia(elem) {
    switch (elem.type) {
      case 'folder':
        /* GENERATE NEW FOLDER */
        console.log("repair folder")
        this._firebase.addMedia('folder', elem.name, { displayName: elem.displayName }).then(d => {
          console.log(d.id)
          elem.id = d.id;
          this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
            this.latestUpdate = d; this.latestUpdateChange.emit(d);
          })
        })
        break;
      case 'file':
        this._firebase.getFileFromName(elem.name).then(f => {

          if (f) {
            f.defaultName = elem.displayName
            this._firebase.addMedia('file', elem.name, f).then(d => {
              console.log(d.id)
              elem.id = d.id;
              this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                this.latestUpdate = d; this.latestUpdateChange.emit(d);
              })
            })

          }
        })
        console.log("repair file")
        break;
      case 'web':

        this._firebase.getWebConfigFromName(elem.name, this._shareVar.selectedDevice).then(d => {

          d[0].data.urlConfig.forEach((item) => {
            if (item.name == elem.name || item.name == elem.displayName) {

              this._firebase.addMedia('web', elem.name, { url: item.url, thumbnail: item.thumbnailUrl || '', id: item.id, filename: item.filename || '' }).then(m => {
                elem.id = m.id
                this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                  this.latestUpdate = d; this.latestUpdateChange.emit(d);
                })

              })

            }
          })


        })


      //this._firebase.addMedia('web', elem.name, {name: elem.name, url:})
      default:
        break;
    }
    console.log(elem)
  }

  deleteMedia(elem) {


    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('warningDeleteElement') }
    })


    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId).then(d => {
          if (d) {

            let promise = [];

            if (elem.type == 'file')
              promise.push(this._firebase.getDocDataAndDeleteFile(elem.id))
            else
              promise.push(this._firebase.deleteMedia(elem.id, this._shareVar.selectedDevice))



            this._utils.deleteElementFromNestedArray(this.items, elem.id)
            this._utils.deleteElementFromNestedArray(this.contentData, elem.id)



            Promise.all(promise).then(() => {
              this.initTable();
              this._ref.detectChanges();

              this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                this.latestUpdate = d; this.latestUpdateChange.emit(d);



              })
            })

          }
        })





      }
    })



  }

  printElement(element) {
    //console.log(element)
  }

  uploadThumbnail(item) {
    this.eventDispatcher('uploadThumbnail', item)
  }

  deleteThumbnail(item) {
    this.eventDispatcher('deleteThumbnail', item)
  }


  eventDispatcher(elem, item) {
    this.contentListEvent.emit({ type: elem, item: item })
  }

  calendarIsOk(elem) {
    if (elem.mediaOptions && elem.mediaOptions.lifecycle) {

      let start = elem.mediaOptions.lifecycle.start// as Timestamp
      let end = elem.mediaOptions.lifecycle.end //as Timestamp
      if (start.nanoseconds || start.seconds)
        start = new Date(start.seconds * 1000 + start.nanoseconds / 1000000)
      else if (typeof start == 'string')
        start = new Date(start)
      else if (typeof start.getMonth === 'function') {

      }
      else
        start = start.toDate();


      if (end.nanoseconds || end.seconds)
        end = new Date(end.seconds * 1000 + end.nanoseconds / 1000000)
      else if (typeof end == 'string')
        end = new Date(end)
      else if (typeof end.getMonth === 'function') {

      }
      else
        end = end.toDate();

      if (start > new Date() || end < new Date())
        return false;
      else
        return true
    }
    else
      return true;

  }

  managePeriod(item) {
    this.dialogRef = this.dialog.open(DateManagementComponent, {

      height: '30vh',
      data: item.mediaOptions
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {


          this._firebase.updateModule(this.moduleId, { latestUpdate: d })
          this.latestUpdate = d; this.latestUpdateChange.emit(d);
          this._firebase.updateMediaData({ lifecycle: result.lifecycle }, item.id)
        })
      }
    })

  }

  canAddThumbnail(item) {

    if (item.name.match(/\.(mp4)$/)) {
      return true
    }

    else if (item.name.match(/\.(pdf)$/)) {
      return true
    }
    else if (item.type == 'file') {
      return true
    }
  }

  manageTags(item) {
    // console.log(item)


    this.dialogRef = this.dialog.open(TagsmanagementComponent, {

      height: '50vh',
      data: {
        mediaOptions: item.mediaOptions,
        id: item.id,
        moduleId: this.moduleId
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //   console.log("DATA:", result)


        item.mediaOptions = result;

        this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this._firebase.updateMediaData({ tags: result.tags }, item.id)
          this.latestUpdate = d; this.latestUpdateChange.emit(d);
        })

        // console.log(this.contentData)
      }
    })


  }

  setSVGContent(item) {
    console.log(item, this.selectedFolder, this.items)

    this.dialogRef = this.dialog.open(SvginteractmodalComponent, {
      height: "70vh",
      width: "70vw",
      data: {
        svg: item,
        folderContent: this.items
      }
    })

    this.dialogRef.afterClosed().subscribe(d => {
      console.log(d)

      if (d) {
        this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d; this.latestUpdateChange.emit(d);
          this._firebase.updateMediaData({ customDataSVG: item.mediaOptions.customDataSVG }, item.id)
        })
      }

    })

  }

  moveTo(id) {

    console.log(id)

    /*let elems = this._utils.getAllNestedArrayElement(this.dataSource, id);
   
    console.log("MOVE TO:", elems)*/


    this.dialogRef = this.dialog.open(ListSelectionModalComponent, {

      height: '50vh',
      data: { data: this.contentData, id: id, type: "folder", buttonLabel: 'OK' }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {


        if (result.currentValue[0].root && this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId)) {

          let elem = this._utils.getFolderFromId(this.contentData, id)

          this._utils.deleteElementFromNestedArray(this.contentData, id);

          this.contentData.push(elem);

        }
        else {
          let targetId = result.currentValue[0].id;

          this._utils.moveElement(this.contentData, targetId, id)
        }




        this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d; this.latestUpdateChange.emit(d);
        })

      }
    });
  }

  checkIfSVG(item: any, index: number) {

    if (item.name.match(/\.(svg|SVG)$/)) {
      if (index == 0)
        this.svgCount = 0;
      else
        this.svgCount++

      if (this.svgCount == 0)
        return true;
      else
        return false;

    }


  }

  getFileUrl(item) {
    //    console.log("TYPE:", item.type, item)
    if (item.name.match(/\.(jpeg|jpg|gif|png|svg|SVG|JPEG|JPG|GIF|PNG)$/)) {
      if (item.mediaOptions) {
        return item.mediaOptions.url
      }

      else {
        return item.url
      }

    }
    else if (item.name.match(/\.(mp4|pdf)$/) || item.type == 'quiz') {
      //    console.log("THIS IS A VIDEO", item)
      if (item.mediaOptions && item.mediaOptions.thumbnail)
        return item.mediaOptions.thumbnail.url;
      else
        return null
    }
    else if (item.type == 'web') {
      if (item.mediaOptions != undefined)
        return item.mediaOptions.thumbnailUrl
      else
        return null;
    }
    else if (item.type == 'folder') {
      if (item.mediaOptions != undefined) {
        //  console.log(item.mediaOptions.thumbnail.url, item.mediaOptions.thumbnail.url.length)

        if (item.mediaOptions.thumbnail.url.length > 0)
          return item.mediaOptions.thumbnail.url
        else {

          return "assets/ui/folder.png"
        }

      }

    }
    return null
  }

  rename(elem) {
    // console.log(id)


    //   console.log(elem)
    let tmp
    if (elem.displayName)
      tmp = elem.displayName.replace(`.${elem.name.split('.')[elem.name.split('.').length - 1]}`, '')
    else
      tmp = elem.name.replace(`.${elem.name.split('.')[elem.name.split('.').length - 1]}`, '')
    //   console.log(tmp)

    //console.log(elem)
    var _data = {

      type: 'text',
      title: this.translation.transform('enterNewName'),
      buttonLabel: this.translation.transform('validate'),
      currentValue: tmp,//elem.name.split('.')[elem.name.split('.').length - 1],
      buttonColor: 'accent',
      elemType: elem.type,

    };


    if (elem.mediaOptions)
      _data['elemLang'] = elem.mediaOptions.langArray
    //  elemLang: 

    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '50vh',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId
        ).then(d => {

          if (d) {
            if (elem.type != 'file') {
              this._utils.renameNode(result.currentValue, elem.id, this.contentData)


              /*If Folder, copy displayName in langArray 'fr'*/
              if (elem.type == 'folder') {

                //console.log(result.elemLang)
                if (d && result.elemLang) {
                  if (!result.elemLang.find(e => e.tag == 'fr')) {
                    result.elemLang.push({ tag: 'fr', value: result.currentValue })
                  }
                  else {
                    result.elemLang[result.elemLang.findIndex(e => e.tag == 'fr')].value = result.currentValue;
                  }


                  this._utils.renameTranslationNode(result, elem.id, this.contentData)

                  this._firebase.updateMediaDisplayNameAndTranslation(elem.id, result.currentValue, result.elemLang, elem).then(() => {

                    this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                      this.latestUpdate = d; this.latestUpdateChange.emit(d)
                    })
                  }).catch(err => {
                    console.log("Error updating media name", err)
                  })
                }



              }
              else {
                this._firebase.updateMediaDisplayName(elem.id, result.currentValue, elem).then(() => {
                  this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                    this.latestUpdate = d; this.latestUpdateChange.emit(d)
                  })
                }).catch(err => {
                  console.log("Error updating media name", err)
                })
              }




            }
            else if (elem.type == 'file') {

              let extension = elem.name.split('.')[elem.name.split('.').length - 1]

              this._utils.renameNode(`${result.currentValue}.${extension}`, elem.id, this.contentData)


              this._firebase.updateMediaDisplayName(elem.id, result.currentValue, elem).then(() => {
                this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                  this.latestUpdate = d; this.latestUpdateChange.emit(d)
                })
              })

            }
          }







          /*if (result.currentValue.length > 0)
   
   
            if (item != undefined)
              this.addElementToChildren(item.id, result.currentValue, 'folder').then((data) => {
                this._firebase.updateConfigModule({ fileTree: data }, this.moduleId)
              })
            else {
              this.addElementToChildren(null, result.currentValue, 'folder').then((data) => {
                this._firebase.updateConfigModule({ fileTree: data }, this.moduleId)
              })
            }*/
          /*
   
          this._utils.renameNode(result.currentValue, node.id, this.dataSource)
   
          this._firebase.updateMediaName(node.id, result.currentValue).then(() => {
            this._firebase.updateConfigModule({ fileTree: this.dataSource }, this.moduleId)
          })*/

        })
      }

    });

    /*.then((d) => {
   
    })*/

    //this._firebase.updateMediaName(node.id, node.name)

  }

}


